import { create } from 'zustand';
import apiClient from '../service/apiClient';
import { Page } from '../type/type';
import { toast } from 'react-toastify';

export interface IFortuneLabDailyStats {
  targetDate: string;
  dailyNewUserCount: number;
  dailyExistingUserCount: number;
  dailyTotalUserCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface IFortuneLabTrackingStats {
  trkId: string;
  recordDate: string;
  landedUserCount: number;
  resultUserCount: number;
  createdAt: string;
  updatedAt: string;
}

interface DailyStatsResponse extends Page {
  content: IFortuneLabDailyStats[];
}

interface TrackingStatsResponse extends Page {
  content: IFortuneLabTrackingStats[];
}

type FortuneLabStatisticsState = {
  dailyStats: IFortuneLabDailyStats[];
  dailyStatsPage: Page | null;
  trackingStats: IFortuneLabTrackingStats[];
  trackingStatsPage: Page | null;
};

type FortuneLabStatisticsAction = {
  fetchDailyStats: (page?: number, size?: number) => Promise<void>;
  fetchTrackingStats: (trkId?: string, page?: number, size?: number) => Promise<void>;
};

export const useFortuneLabStatisticsStore = create<
  FortuneLabStatisticsState & FortuneLabStatisticsAction
>(set => ({
  dailyStats: [],
  dailyStatsPage: null,
  trackingStats: [],
  trackingStatsPage: null,

  fetchDailyStats: async (page = 0, size = 20) => {
    try {
      const response = await apiClient.get<DailyStatsResponse>(
        '/fortune-lab/statistics/daily',
        {
          params: {
            page,
            size,
            sort: 'targetDate,desc',
          },
        }
      );
      const { content, ...rest } = response.data;
      set({ dailyStats: content, dailyStatsPage: rest });
    } catch (error) {
      console.error(error);
      toast.error('일별 통계를 불러오지 못했습니다.');
    }
  },

  fetchTrackingStats: async (trkId, page = 0, size = 20) => {
    try {
      const response = await apiClient.get<TrackingStatsResponse>(
        '/fortune-lab/statistics/tracking',
        {
          params: {
            trkId,
            page,
            size,
            sort: 'recordDate,desc',
          },
        }
      );
      const { content, ...rest } = response.data;
      set({ trackingStats: content, trackingStatsPage: rest });
    } catch (error) {
      console.error(error);
      toast.error('트래킹 통계를 불러오지 못했습니다.');
    }
  },
}));
